import React from "react";

const Error = () => {
  return(
    <div>
      <main style={{marginTop: '70px'}}>
        <p>Error: Path does not exist!!</p>
      </main>
    </div>
  );
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/error.jsx